import React, { useState, useEffect } from 'react';
import { ButtonDictionaryItem } from 'types/ButtonDictionaryItem';
import { Tab, TabList, Tabs } from 'react-aria-components';
import './GroupButtons.scss';

interface GroupButtonsProps {
    buttonNames: ButtonDictionaryItem[];
    alwaysDisplayIndex?: number;
    selectedIndex: number;
    setCurrentIndex: (value: number) => void;
}

const GroupButtons: React.FC<GroupButtonsProps> = ({ selectedIndex, buttonNames, alwaysDisplayIndex, setCurrentIndex }) => {
    const [selectedComponentIndex, setIndex] = useState<number>(selectedIndex ?? 0);

    useEffect(() => {
        if (selectedIndex !== undefined && selectedIndex !== null) {
            setIndex(selectedIndex);
        }
    }, [selectedIndex]);

    const componentClick = () => {
        const nextIndex = (selectedComponentIndex + 1) % buttonNames.length;
        setCurrentIndex(nextIndex);
    };

    const cloneComponentElement = (index: number) => {
        const componentElement = buttonNames[index]?.component;
        return componentElement ? React.cloneElement(componentElement, { key: index, componentClick }) : null;
    };

    return (
        <div className='modal-content-container'>
            <Tabs className="tabsGroup" data-orientation='vertical' selectedKey={`tab-${selectedComponentIndex}`} onSelectionChange={(key) => setCurrentIndex(Number(key.toString().split('-')[1]))}>
                <TabList
                    aria-label=''
                    className="tabList"
                >
                    {buttonNames.map(({ label }, index) => (
                        <Tab
                            key={index}
                            id={`tab-${index}`}
                            className={({ isSelected }) => `
                               tab btn 
                                ${isSelected ? 'activeButton' : ''}
                            `}
                        >
                            <div>{label}</div>
                        </Tab>
                    ))}
                </TabList>
            </Tabs>
            <div className=''>
                {selectedComponentIndex ? cloneComponentElement(alwaysDisplayIndex) : <></>}
                {buttonNames.map((_, index) => { return selectedComponentIndex === index && cloneComponentElement(index) }
                )}
            </div>
        </div>
    );
};

export default GroupButtons;